import { memo } from 'react';
import {
  GLOBAL_SEARCH_ACTIVE_CATEGORY_CLASS,
  GLOBAL_SEARCH_FILTER_PANEL_CHIP_ACTIVE_CLASS,
  GLOBAL_SEARCH_FILTER_PANEL_CHIP_INACTIVE_CLASS,
  GLOBAL_SEARCH_FILTER_PANEL_CLASS,
  GLOBAL_SEARCH_FILTER_PANEL_SECTION_LABEL_CLASS,
} from './constants.js';

/**
 * @param {object} props
 * @param {string[]} props.selectedIds
 * @param {(id: string) => void} props.onToggle
 * @param {Array<{ id: string, title: string, options: Array<{ id: string, label: string }> }>} props.sections
 * @param {() => void} props.onClearAll
 * @param {() => void} props.onDone
 * @param {Record<string, string>} [props.labels]
 */
const TopbarGlobalSearchFilterPanel = memo(function TopbarGlobalSearchFilterPanel({
  selectedIds = [],
  onToggle,
  sections = [],
  onClearAll,
  onDone,
  labels = {},
}) {
  const hasSelection = selectedIds.length > 0;

  return (
    <div className={GLOBAL_SEARCH_FILTER_PANEL_CLASS}>
      {sections.map((section) => (
        <section key={section.id} className="flex w-full flex-col gap-2">
          <p className={GLOBAL_SEARCH_FILTER_PANEL_SECTION_LABEL_CLASS}>{section.title}</p>
          <div className="flex flex-wrap content-start gap-2">
            {section.options.map((option) => {
              const isActive = selectedIds.includes(option.id);
              return (
                <button
                  key={option.id}
                  type="button"
                  aria-pressed={isActive}
                  onClick={() => onToggle?.(option.id)}
                  className={
                    isActive
                      ? GLOBAL_SEARCH_FILTER_PANEL_CHIP_ACTIVE_CLASS
                      : GLOBAL_SEARCH_FILTER_PANEL_CHIP_INACTIVE_CLASS
                  }
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </section>
      ))}

      <div className="flex w-full items-center justify-end gap-2">
        <button
          type="button"
          onClick={onClearAll}
          className="inline-flex h-7 items-center rounded-lg px-3 text-xs font-medium leading-5 text-[#2A2A2A] transition-colors hover:bg-black/[0.04] dark:text-gray-200 dark:hover:bg-white/[0.06]"
        >
          {labels.clearAll ?? labels.clearFilters ?? 'Clear all'}
        </button>
        <button
          type="button"
          onClick={onDone}
          disabled={!hasSelection}
          className={[
            'inline-flex h-7 items-center rounded-lg px-3 text-xs font-medium leading-5 transition-colors',
            hasSelection
              ? GLOBAL_SEARCH_ACTIVE_CATEGORY_CLASS
              : 'cursor-not-allowed bg-violet-300/60 text-white/80 dark:bg-violet-900/40 dark:text-violet-200/60',
          ].join(' ')}
        >
          {labels.done ?? 'Done'}
        </button>
      </div>
    </div>
  );
});

export default TopbarGlobalSearchFilterPanel;
